import styled from "styled-components"

const modalBaseOffset = 250
const modalInnerOffset = 65

const topButtonOffset = 30
const buttonOffset = 10
const buttonHeight = 38

export const ModalContainer = styled.div`
    position: absolute;
    width: calc(100% - ${(props) => props.theme.layoutSizes.sidebarWidth + props.theme.scrollbarSize}px);
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 10;
`
export const ModalWrapper = styled.div<{
    show: boolean
    showBackground: boolean
    animateBackground: boolean
    timeout: number
}>`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    top: 0;
    left: ${(props) => (props.show ? 0 : "100%")};
    background: ${(props) => (props.showBackground ? props.theme.modalBackground : "transparent")};
    transition: background ${(props) => (props.animateBackground ? props.timeout : 0)}ms ease,
                left 0ms ${(props) => (props.show ? 0 : props.timeout)}ms; //show immediately, hide with delay
`
export const ModalContentWrapper = styled.div<{
    show: boolean
    offsetMultiplier: number
    timeout: number
}>`
    position: relative;
    height: 100%;
    width: calc(100% - ${(props) => modalBaseOffset + props.offsetMultiplier * modalInnerOffset}px);
    float: right;
    top: 0;
    right: ${(props) => (props.show ? 0 : "-100%")};
    background: ${(props) => props.theme.pageContentBackground};
    transition: right ${(props) => props.timeout}ms ease;
`
export const ModalContent = styled.div<{
    showShadow: boolean
}>`
    position: absolute;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    box-shadow: 0 0px 5px 4px ${(props) => (props.showShadow ? "rgba(0, 0, 0, 0.4)" : "transparent")};
`
export const CloseButtonWrapper = styled.div<{
    offsetMultiplier: number
    timeout: number
}>`
    display: flex;
    position: absolute;
    top: ${(props) => (props.offsetMultiplier * (buttonHeight + buttonOffset) + topButtonOffset)}px;
    height: ${buttonHeight}px;
    transform: translateX(-100%);
    transition: top ${(props) => props.timeout}ms ease;

    &:hover i {
        border-color: ${(props) => props.theme.modalCloseButtonBorderColor};
        transition: ${(props) => props.theme.defaultTransition};
        opacity: 1;
    }
`
export const CloseButton = styled.div<{
    show: boolean
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${buttonHeight}px;
    width: ${(props) => (props.show ? buttonHeight : buttonHeight / 2)}px;
    border-top-left-radius: ${buttonHeight / 2}px;
    border-bottom-left-radius: ${buttonHeight / 2}px;
    transform: translateX(2px);
    background: ${(props) => props.theme.modalCloseButtonBackground};
    transition: width 0.2s ease;

    & > i {
        display: ${(props) => (props.show ? "block" : "none")};
        padding: 4px;
        font-weight: bold;
        border: solid 2px transparent;
        border-radius: 50%;
        opacity: 0.7;
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const CloseButtonLabel = styled.span`
    height: ${buttonHeight}px;
    line-height: ${buttonHeight}px;
    padding: 0 10px 0 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-transform: uppercase;
    user-select: none;
    font-weight: bold;
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.xs}px;
    background: ${(props) => props.theme.modalCloseButtonBackground};
`
